export default {
	computed: {
		defaultFilters() {
			return {
				job_type: null,
				location_type: null,
				salary_from: null,
				salary_to: null,
				is_bursary: this.viewingBursaries,
			}
		},

		viewingBursaries() {
			return this.$route.fullPath.includes('bursaries');
		},
	},

	methods: {
		async resetFilters() {
			await this.$store.dispatch('jobs/setFilters', this.defaultFilters);
		},

		async resetCursor() {
			await this.$store.dispatch('jobs/setCursor', null);
		},

		async resetSearch() {
			await this.$store.dispatch('jobs/setSearch', null);
		},

		async clearFilteredJobs() {
			await this.resetFilters();
			await this.resetCursor();
			await this.resetSearch();
			await this.$store.dispatch('jobs/setFilteredJobs', null);
			await this.$store.dispatch('jobs/getFilteredJobs');
		},
	},
}
